import React, { useEffect, createElement } from 'react';
import { LulutoxLanding } from './pages/LulutoxLanding';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://trk.healthproductsguru.com/track.js?rtkcmpid=696598e59cffb3d645728df0';
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return <LulutoxLanding data-id="element-0" />;
}